import React from 'react'
import {translate} from 'react-i18next'

import Link from 'components/Link'
import ErrorLinksTitle from './ErrorLinksTitle'

import {getAboutLink, getAgbLink, getDsbLink, getImpressumLink, getSupportLink} from 'utils/languageUtils'

const ErrorLinks = ({t, showAGBLink = true, showDSBLink = true}) => (
  <>
    <ErrorLinksTitle light>{t('errors.links-title')}</ErrorLinksTitle>
    <Link to={getSupportLink()} info external block target="_blank" rel="noreferrer">
      {t('errors.links.support')}
    </Link>
    <Link to={getAboutLink()} info external block target="_blank" rel="noreferrer">
      {t('errors.links.about')}
    </Link>
    <Link to={getImpressumLink()} info external block target="_blank" rel="noreferrer">
      {t('errors.links.impressum')}
    </Link>
    {showAGBLink && (
      <Link to={getAgbLink()} info external block target="_blank" rel="noreferrer">
        {t('errors.links.tos')}
      </Link>
    )}
    {showDSBLink && (
      <Link to={getDsbLink()} info external block target="_blank" rel="noreferrer">
        {t('errors.links.pp')}
      </Link>
    )}
  </>
)

export default translate()(ErrorLinks)
